import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants/";
import { utilService } from "../../services";
import {
  AddPhoneNumberResponse,
  BedsData,
  FormattedGetSitesData,
  FormattedUnitsData,
  GetBedsListResponse,
  GetPhoneListResponse,
  GetSitesApiResponse,
  GetUnitNurseListResponse,
  GetUnitsApiResponse,
  PhonesData,
} from "./NurseMgmtDataModels";
import { ApiResponse } from "../../models";

let initialBedList: BedsData[];
let initialPhoneList: PhonesData[];

const getSites = async (reqParams: {}): Promise<FormattedGetSitesData> => {
  return await apiService
    .apiCall(
      `sboard/unit/my-patient/site-list/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as GetSitesApiResponse;
      return {
        responseData: response.result.map(
          (site: { siteId: number; siteName: string }) => {
            return { dataId: site.siteId, dataName: site.siteName };
          }
        ),
        isSuccess: response.isSuccess,
        message: response.message,
      } as FormattedGetSitesData;
    })
    .catch((err) => {
      return {
        responseData: [],
        isSuccess: err.isSuccess,
        message: err.message,
      } as FormattedGetSitesData;
    });
};

const getUnits = async (reqParams: {}): Promise<FormattedUnitsData> => {
  return await apiService
    .apiCall(
      `sboard/unit/list-all-chargenurse/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as GetUnitsApiResponse;
      return {
        response: response,
        formattedUnitData: response.result.map(
          (unit: { unitId: number; unitName: string }) => {
            return { name: unit.unitName, value: unit.unitId };
          }
        ),
      } as FormattedUnitsData;
    })
    .catch((err) => {
      return {
        response: err,
        formattedUnitData: [],
      } as FormattedUnitsData;
    });
};

const getNurses = async (reqParams: {}): Promise<GetUnitNurseListResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/unit-nurse-list/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as GetUnitNurseListResponse;
      return response;
    })
    .catch((err) => {
      return err as GetUnitNurseListResponse;
    });
};

const getPhones = async (reqParams: {}): Promise<GetPhoneListResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/assign-phone/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res: any) => {
      initialPhoneList = res.result;
      return res as GetPhoneListResponse;
    })
    .catch((err) => {
      return err as GetPhoneListResponse;
    });
};

const getBeds = async (reqParams: {}): Promise<GetBedsListResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/chargenurse-bed-list/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res: any) => {
      initialBedList = res.result;
      return res as GetBedsListResponse;
    })
    .catch((err) => {
      return err as GetBedsListResponse;
    });
};

const addPhone = async (reqParams: {}): Promise<AddPhoneNumberResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/assign-phone/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res: any) => {
      return res as AddPhoneNumberResponse;
    })
    .catch((err) => {
      return err as AddPhoneNumberResponse;
    });
};

const getSearchedNurses = async (reqParams: {}): Promise<GetUnitNurseListResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/search-nurse/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as GetUnitNurseListResponse;
      return response;
    })
    .catch((err) => {
      return err as GetUnitNurseListResponse;
    });
};

const getSiteIdForUnit = (unitList: [], unitId: number): number => {
  const unitObj: { site: number; unitId: number }[] = unitList.filter(
    (unitObj: { unitId: number }) => {
      return unitObj.unitId === unitId;
    }
  );
  return unitObj[0].site;
};

const addNurse = async (reqParams: {}): Promise<GetUnitNurseListResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/search-nurse/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res: any) => {
      const response = res as GetUnitNurseListResponse;
      return response;
    })
    .catch((err) => {
      return err as GetUnitNurseListResponse;
    });
};

const getInitialList = (listType: string): BedsData[] | PhonesData[] => {
  return listType === "bed" ? initialBedList : initialPhoneList;
};

const updateNurseData = async (reqParams: {}): Promise<ApiResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/assign-phone-save/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res: any) => {
      const response = res as ApiResponse;
      return response;
    })
    .catch((err) => {
      return err as ApiResponse;
    });
};

export const NurseManagementService = {
  getSites,
  getUnits,
  getNurses,
  getPhones,
  getBeds,
  addPhone,
  getSearchedNurses,
  getSiteIdForUnit,
  addNurse,
  getInitialList,
  updateNurseData,
};
